// extracted by mini-css-extract-plugin
export default {"button":"Bm-z","reviewSort":"Cm-z"};